import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { BiSolidDashboard } from "react-icons/bi";
import { MdAddchart, MdAreaChart } from "react-icons/md";
import { Card, Col, Container, Form, Row } from "react-bootstrap";
import { studyEDCDashboardGraph } from "../../../APIServices/studyEDCDashboardGraph";
import { PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import UseToggle from "../../../Hooks/UseToggle";
import EDCRecentActivity from "./EDCRecentActivity";
import ModeWiseStudyGraph from "./ModeWiseStudyGraph";
import AddComponents from "./DynamicGraph/AddComponents";
import AddNewDynamicGraph from "./DynamicGraph/AddNewDynamicGraph";
import EDCDynamicGraphList from "./DynamicGraph/EDCDynamicGraphList";
import StandardDynamicGraphList from "./DynamicGraph/StandardDynamicGraphList";

const StudyDashboard = ({ tableRef, onMouseDown }) => {
  const toggles = UseToggle();
  const { studyId } = useParams();
  const [greeting, setGreeting] = useState("");
  const [selected, setSelected] = useState([]);
  const category = JSON.parse(localStorage.getItem("role"));
  const [dashboardLoader, setDashboardLoader] = useState(false);
  const userName = JSON.parse(localStorage.getItem("firstName"));
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [standardGraphRefresh, setStandardGraphRefresh] = useState("");

  const getGreeting = () => {
    const currentTime = new Date().getHours();
    let greeting;

    if (currentTime >= 5 && currentTime < 12) {
      greeting = "Good Morning";
    } else if (currentTime >= 12 && currentTime < 18) {
      greeting = "Good Afternoon";
    } else {
      greeting = "Good Evening";
    }
    setGreeting(greeting);
  };

  const getStudyDashboardComponentData = async () => {
    setDashboardLoader(true);
    let data = await studyEDCDashboardGraph.getStudyDashboardComponentData(
      studyId,
      category,
      StudyMode
    );
    setSelected(data?.data || []);
    setDashboardLoader(false);
  };

  useEffect(() => {
    getGreeting();
    getStudyDashboardComponentData();
  }, [studyId]);

  return (
    <>
      <div className="chart__overview">
        <div className="hstack gap-2 p-1 justify-content-end border-bottom">
          {StudyMode === "DBP Mode" && (
            <>
              <button
                title="View Chart List"
                className="updateProfile hstack gap-1"
                onClick={() => toggles?.setToggle2()}
              >
                <MdAddchart /> Add Graph
              </button>
              <div className="vr"></div>
              <button
                title="Edit Chart"
                className="updateProfile hstack gap-1"
                onClick={() => toggles.setToggle()}
              >
                <MdAreaChart /> Standard Graph
              </button>
              <div className="vr"></div>
              <button
                title="Edit Chart"
                className="updateProfile hstack gap-1"
                onClick={() => toggles.setToggle1()}
              >
                <MdAreaChart /> EDC Graph
              </button>
              <div className="vr"></div>
            </>
          )}
          <button
            title="Add Component"
            className="updateProfile hstack gap-1"
            onClick={() => toggles.setToggle3()}
          >
            <BiSolidDashboard /> Add Component
          </button>
        </div>
        <div className="text-center py-2 border-bottom">
          <h5 className="m-0">
            {greeting}! {userName}
          </h5>
          <p className="m-0">Welcome to your study dashboard.</p>
        </div>
        {dashboardLoader ? (
          <PageLoader />
        ) : (
          <Container fluid>
            <Row>
              <Form.Group
                as={Col}
                md={selected.includes("Recent activity") ? 8 : 12}
                className="overflow-auto border-end pt-2 p-0"
                style={{ height: "calc(100vh - 245px)" }}
              >
                <ModeWiseStudyGraph
                  selected={selected}
                  StudyMode={StudyMode}
                  standardGraphRefresh={standardGraphRefresh}
                />
              </Form.Group>
              {selected.includes("Recent activity") && (
                <Form.Group as={Col} sm={4} className="pt-2">
                  <Card className="border bg-light">
                    <Card.Body>
                      <Card.Title>Recent activity</Card.Title>
                      <Card.Text className="m-0 mt-2">
                        <div
                          className="overflow-auto"
                          style={{ height: "calc(100vh - 320px)" }}
                        >
                          <EDCRecentActivity StudyMode={StudyMode} />
                        </div>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
            </Row>
          </Container>
        )}
        <StandardDynamicGraphList
          Show={!toggles.toggle}
          Hide={toggles.setToggle}
          tableRef={tableRef}
          onMouseDown={onMouseDown}
          setStandardGraphRefresh={setStandardGraphRefresh}
        />
        <EDCDynamicGraphList
          Show={!toggles.toggle1}
          Hide={toggles.setToggle1}
          tableRef={tableRef}
          onMouseDown={onMouseDown}
          setStandardGraphRefresh={setStandardGraphRefresh}
        />
        <AddNewDynamicGraph
          Show={!toggles.toggle2}
          Hide={toggles.setToggle2}
          setStandardGraphRefresh={setStandardGraphRefresh}
        />
        <AddComponents
          Show={!toggles.toggle3}
          Hide={toggles.setToggle3}
          tableRef={tableRef}
          onMouseDown={onMouseDown}
          studyId={studyId}
          category={category}
          StudyMode={StudyMode}
          selected={selected}
          setSelected={setSelected}
          getStudyDashboardComponentData={getStudyDashboardComponentData}
          setStandardGraphRefresh={setStandardGraphRefresh}
        />
      </div>
    </>
  );
};

export default StudyDashboard;
